import * as React from 'react';
import styled from 'styled-components';
import { ReactStateType } from '../../containers_v2/map/Map';
import { BorderColor, GreySidely, SurfaceColor } from '../../styles/global/css/Utils';
import { useClampToViewport } from '../../utils/customHooks';
import { subscribeToPopupState } from '../popup/Popup';

type ButtonType = (opts: { setIsOpen: React.Dispatch<React.SetStateAction<boolean>>, isOpen: boolean }) => React.ReactNode;

export default function Dropdown2(props: { button: ButtonType, children: React.ReactNode | ButtonType, isOpenState?: ReactStateType<boolean>, noClamp?: boolean, bottom?: boolean }) {
	const [popupOpen, setPopupOpen] = props.isOpenState ?? React.useState(false);
	const popupWrapperRef = React.useRef<HTMLDivElement>();
	const [popupRef, popupStyle] = useClampToViewport(popupOpen);
	const setRef = React.useCallback((ref: React.MutableRefObject<HTMLDivElement | undefined | null>) => (node: HTMLDivElement | undefined | null) => ref.current = node, []);

	subscribeToPopupState(popupOpen, () => setPopupOpen(false), false, false, popupWrapperRef);

	return <ButtonAndPopupWrapper innerRef={setRef(popupWrapperRef)}>
		{props.button({ setIsOpen: setPopupOpen, isOpen: popupOpen })}
		{popupOpen && <DropdownPopup bottom={props.bottom} innerRef={setRef(popupRef)} style={props.noClamp ? undefined : popupStyle}>
			{typeof props.children === 'function' ? props.children({ setIsOpen: setPopupOpen, isOpen: popupOpen }) : props.children}
		</DropdownPopup>}
	</ButtonAndPopupWrapper>;
}

export function HoverPopup(props: { button: JSX.Element, children: React.ReactNode }): JSX.Element {
	if (!props.children) return props.button;
	return <Test>
		{props.button}
		<DropdownPopup>
			{props.children}
		</DropdownPopup>
	</Test>;
}

const ButtonAndPopupWrapper = styled.div`
	font-size: 14px;
	position: relative;
`;


const DropdownPopup = styled.div<{ bottom?: boolean }>`
	position: absolute;
	${p => p.bottom ? 'bottom' : 'top'}: calc(100% + 5px);
	left: 0;
	background-color: ${SurfaceColor};
	border: 1px solid ${BorderColor};
	z-index: 10;
	border-radius: 5px;
	padding: 10px;
	display: flex;
	flex-direction: column;
	gap: 5px;
	box-shadow: ${GreySidely} 0px 1px 5px;
`;

const Test = styled.div`
	position: relative;

	& > ${DropdownPopup} {
		z-index: -1;
		opacity: 0;
	}

	&:hover > ${DropdownPopup} {
		z-index: 2;
		display: flex !important;
		opacity: 1;
		transition: opacity 0s ease-in-out 0.3s;
		min-width: 150px;
	}
`;
